/* HAND-AUTHORED (the artifact pipeline was unavailable for this chapter) — chapter "memory".
 * Same structure as the generated files: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. */

import type { NodeDef } from '../../types';

export const N_MEMORY: NodeDef = {
  "id": "memory",
  "tagKey": "path:memory.tag",
  "x": 880,
  "y": 40,
  "w": 220,
  "h": 116,
  "titleKey": "path:memory.title",
  "subKey": "path:memory.sub",
  "blocks": [
    {
      "id": "memory.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:memory.b1.title",
      "bodyKey": "path:memory.b1.body",
      "flowKey": "path:memory.b1.flow",
      "read": [
        "memsurvey"
      ]
    },
    {
      "id": "memory.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:memory.b2.title",
      "film": "f-memory"
    },
    {
      "id": "memory.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:memory.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:memory.b3o.opts.0.n",
            "wKey": "path:memory.b3o.opts.0.w",
            "uKey": "path:memory.b3o.opts.0.u",
            "cKey": "path:memory.b3o.opts.0.c",
            "slug": "full-transcript"
          },
          {
            "nKey": "path:memory.b3o.opts.1.n",
            "wKey": "path:memory.b3o.opts.1.w",
            "uKey": "path:memory.b3o.opts.1.u",
            "cKey": "path:memory.b3o.opts.1.c",
            "slug": "rolling-summary"
          },
          {
            "nKey": "path:memory.b3o.opts.2.n",
            "wKey": "path:memory.b3o.opts.2.w",
            "uKey": "path:memory.b3o.opts.2.u",
            "cKey": "path:memory.b3o.opts.2.c",
            "slug": "semantic-store"
          },
          {
            "nKey": "path:memory.b3o.opts.3.n",
            "wKey": "path:memory.b3o.opts.3.w",
            "uKey": "path:memory.b3o.opts.3.u",
            "cKey": "path:memory.b3o.opts.3.c",
            "slug": "profile-store"
          },
          {
            "nKey": "path:memory.b3o.opts.4.n",
            "wKey": "path:memory.b3o.opts.4.w",
            "uKey": "path:memory.b3o.opts.4.u",
            "cKey": "path:memory.b3o.opts.4.c",
            "slug": "episodic-retrieval"
          }
        ],
        "ref": "memgpt"
      }
    },
    {
      "id": "memory.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:memory.b3.title",
      "math": {
        "exprKey": "path:memory.b3.math.expr",
        "readKey": "path:memory.b3.math.read",
        "useKey": "path:memory.b3.math.use",
        "ref": "genagents"
      }
    },
    {
      "id": "memory.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:memory.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:memory.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:memory.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:memory.b4.ex.items.0.why"
          },
          {
            "tKey": "path:memory.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:memory.b4.ex.items.1.why"
          },
          {
            "tKey": "path:memory.b4.ex.items.2.t",
            "bin": 1,
            "whyKey": "path:memory.b4.ex.items.2.why"
          },
          {
            "tKey": "path:memory.b4.ex.items.3.t",
            "bin": 0,
            "whyKey": "path:memory.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};